import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/index'
import Login from '@/pages/login/login'
// import Register from '@/pages/register/register'

Vue.use(Router)

// const VueRouterPush = Router.prototype.push
// Router.prototype.push = function push (to) {
//   return VueRouterPush.call(this.to).catch(err => err)
// }

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // },

  ]
})
router.beforeEach((to, from, next) => {
  if (to.name === 'userSell' && !localStorage.getItem('ship_token')) {
    next({ name: 'login' , params:{type:1}})
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js